export const roomStageIdsMap = {
  construction: 1,
  internalAcceptance: 2,
  acceptance: 3,
  managment: 4,
};

export const roomStepIdsMap = {
  workInProgress: 1,
  workCompleted: 2,
  notReadyForHandover: 3,
  readyForHandover: 4,
  invite: 5,
  registeredForKeyCollection: 6,
  ownerNotCome: 7,
  maintenance: 8,
  readyForAcceptance: 9,
};

export const roomAcceptanceStatusIdsMap = {
  notAccepted: 1,
  acceptedWithComments: 2,
  accepted: 3,
  oneWayTransfer: 4,
};
